import { useSelector } from 'react-redux';
import useAnalyticsReportActions from './_actions';

export const useAnalyticsReport = () => {
    const {
        fetchReportList,
        changeCurrentPage,
        changeRowsPerPage
    } = useAnalyticsReportActions();

    const reportData = useSelector(state => state.analyticsreport.data);
    const currentPage = useSelector(state => state.analyticsreport.currentPage);
    const totalRows = useSelector(state => state.analyticsreport.totalRows);
    const rowsPerPage = useSelector(state => state.analyticsreport.rowsPerPage);
    const isLoading = useSelector(state => state.analyticsreport.isLoading);
    const isError = useSelector(state => state.analyticsreport.isError);
    const errorMessage = useSelector(state => state.analyticsreport.errorMessage);
    
    return {
        reportData,
        currentPage,
        totalRows,
        rowsPerPage,
        isLoading,
        isError,
        errorMessage,

        fetchReportList,
        changeCurrentPage,
        changeRowsPerPage
    }
}

export { default as analyticsReportReducer } from './_reducers';